import React from 'react';
// import img from './val.jpg';
import Call from 'assets/img/icons/call.svg';
import Email from 'assets/img/icons/email.svg';
import { EditIcon, FacebookIcon, LinkedInIcon, SendIcon, TwitterIcon, InstagramIcon } from './components/Icons';
import { Box } from '@mui/material';
import AppIconButton from 'components/new_components/AppIconButton';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import ShareModal from './components/ShareModal';
import { useHistory, useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';
import { GetBusinessUser } from 'api/general';
import { useSelector } from 'react-redux';
import { UpdateBusinessUser } from 'api/general';
import { toast } from 'react-toastify';
import { ReactComponent as EmptyState1 } from 'assets/img/business-empty-1.svg';
import emptystate2 from 'assets/img/business-empty-2.png';
import { Loader2 } from 'lucide-react';

const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#395BA9',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                opacity: 0.5,
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
                ...theme.applyStyles('dark', {
                    opacity: 0.5,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    })
);

export default function Preview() {
    const [open, setOpen] = React.useState(false);
    const history = useHistory();
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const { id } = useParams();

    const user_info = useSelector((state) => state?.authReducers?.user_info);

    const { data: user, refetch } = useQuery({
        queryKey: ['get-user-info'],
        queryFn: () => GetBusinessUser(id),
    });

    const { mutate, isLoading } = useMutation({
        mutationKey: ['updateBusinessUser'],
        mutationFn: UpdateBusinessUser,
        onSuccess: () => {
            toast.success('Profile updated successfully');
            refetch();
        },
        onError: (error) => {
            toast.error(error?.message || 'An error occured');
        },
    });

    if (!user) {
        return (
            <div className="w-full h-[100dvh] lg:h-auto min-h-[100dvh] flex flex-col items-center relative">
                <div className="w-screen h-screen mx-4 flex-col flex items-center justify-center">
                    <Loader2 className="animate-spin w-12 h-12" />
                </div>
            </div>
        );
    }

    return id && !user?.live ? (
        <div className="w-full h-[100dvh] pt-[40.67%] md:pt-0  lg:h-auto min-h-[100dvh] flex flex-col items-center relative">
            <div className="max-w-[80vw] mx-4 flex-col flex items-center justify-center">
                <EmptyState1 className="px-2" />
                <img src={emptystate2} className="" />
                <h3 className="text-[#334155] text-xl mt-4 mb-2 font-bold text-center">
                    Still Loading Their Awesomeness
                </h3>
                <p className="text-gray-500 text-[15px] text-center">
                    This business card is empty... for now. Greatness takes time. Please check back soon!
                </p>
            </div>
        </div>
    ) : (
        <div className="w-full h-[100dvh] pt-[40.67%] md:pt-0  lg:h-auto min-h-[100dvh] flex flex-col items-center relative">
            <ShareModal open={open && !id} handleClose={handleClose} user={user} userId={user?.id} />
            <div className="w-full fixed md:relative h-[40.67%] min-h-[379px] lg:max-h-[450px] overflow-hidden lg:max-w-[520px] lg:rounded-t-3xl top-0">
                <img
                    src={user?.picture_url ? user?.picture_url : ''}
                    className="w-full h-full object-cover object-top relative top-0 left-0"
                />

                {id ? null : (
                    <div className="flex absolute z-10 top-10 w-full px-2.5 lg:px-4 justify-between">
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#fff',
                                borderRadius: '10rem',
                                px: 2,
                                py: 1,
                                textTransform: 'none',
                                fontSize: 14,
                                color: '#334155',
                                fontWeight: '600',
                                '&:hover': {
                                    backgroundColor: '#f1f4f5',
                                },
                            }}
                        >
                            <label className="m-0" htmlFor="picture">
                                Change picture
                            </label>
                            <input
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files?.item(0);
                                    const fileSize = file.size / 1000 / 1000;
                                    if (fileSize > 5) {
                                        toast.info('File too large, minimum of 5MB');
                                    } else {
                                        mutate({ picture: e.target.files[0] });
                                    }
                                }}
                                id="picture"
                                accept="image/png, image/jpeg"
                                hidden
                            />
                        </Button>

                        <div className="flex w-fit gap-1">
                            <Box
                                sx={{
                                    backgroundColor: '#fff',
                                    borderRadius: '10rem',
                                    px: 1,
                                    textTransform: 'none',
                                    fontSize: 14,
                                    color: '#334155',
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <IOSSwitch
                                    checked={user?.live}
                                    onChange={(e) => {
                                        mutate({ live: e.target.checked });
                                    }}
                                    disabled={isLoading}
                                />
                                <span className={`text-[#55BE8B] text-xs ml-2 ${user?.live ? '' : 'opacity-60'}`}>
                                    Live
                                </span>
                            </Box>

                            <AppIconButton
                                onClick={handleOpen}
                                sx={{
                                    backgroundColor: 'white',
                                    w: 40,
                                    h: 40,
                                }}
                            >
                                <SendIcon />
                            </AppIconButton>
                        </div>
                    </div>
                )}
            </div>

            <div className="w-full sm:max-w-[500px] h-[59.33%] mt-[40.67%] md:mt-0 flex flex-col items-center z-10">
                <div className="w-[94%] mb-[2rem] py-4 px-8 text-[#F1FFD6] rounded-3xl backdrop-blur-[8px] shadow-[0px_2px_24px_0px_#2B2B2B0D] h-fit text-center -mt-[25%] lg:-mt-[18%] bg-[#D9D9D999]">
                    <div className={`relative ${id ? 'text-center' : 'text-left'}`}>
                        <h1 className="text-3xl font-semibold capitalize">
                            {(user?.first_name || '--') + ' ' + (user?.last_name || '--')}
                        </h1>
                        <p className="mb-2 text-lg font-medium capitalize">{user?.position || '--'}</p>
                        {id ? null : (
                            <AppIconButton
                                onClick={() => history.push('/business-profile/personal-info')}
                                sx={{
                                    boxShadow: 'none',
                                    position: 'absolute',
                                    top: '0.5rem',
                                    right: '0',
                                    backgroundColor: 'white',
                                    w: 40,
                                    h: 40,
                                }}
                            >
                                <EditIcon />
                            </AppIconButton>
                        )}
                    </div>

                    <div className="flex gap-4 font-semibold mt-3">
                        <a
                            href={`tel:${user?.phone_number}`}
                            target="_blank"
                            rel="noreferrer"
                            className={`${
                                user?.phone_number ? '' : 'pointer-events-none opacity-70'
                            } shadow-[0px_4px_6px_0px_#3D6BA31A] bg-white rounded-full p-3 !text-gray-800 !no-underline w-1/2 flex items-center justify-center gap-2 font-semibold `}
                        >
                            <img src={Call} />
                            Call
                        </a>
                        <a
                            href={`mailto:${user_info?.email}`}
                            target="_blank"
                            rel="noreferrer"
                            className={`${
                                user_info?.email ? '' : 'pointer-events-none opacity-70'
                            } shadow-[0px_4px_6px_0px_#3D6BA31A] bg-white rounded-full p-3 !text-gray-800  !no-underline w-1/2 flex items-center justify-center gap-2 font-semibold`}
                        >
                            <img src={Email} />
                            Email
                        </a>
                    </div>

                    <a
                        href={user?.meeting_link}
                        target="_blank"
                        rel="noreferrer"
                        className={`${
                            user?.meeting_link ? '' : 'pointer-events-none opacity-70'
                        } block mt-3 bg-[#002C72] !text-[#fff] !no-underline w-full rounded-full p-3 font-semibold`}
                    >
                        BOOK A MEETING
                    </a>
                </div>

                <div className="sm:max-w-[500px] text-gray-600 w-[94%] rounded-3xl bg-white p-3 px-4">
                    <div className="flex mb-2">
                        <p className="text-left mb-3 font-medium">Connect with my socials:</p>

                        {id ? null : (
                            <AppIconButton
                                onClick={() => history.push('/business-profile/socials')}
                                sx={{
                                    position: 'relative',
                                    backgroundColor: '#F1F5F9',
                                    w: 40,
                                    h: 40,
                                    ml: 'auto',
                                    boxShadow: 'none',
                                }}
                            >
                                <EditIcon />
                            </AppIconButton>
                        )}
                    </div>
                    {user?.facebook_link || user?.instagram_link || user?.linkedin_link || user?.x_link ? (
                        <div className="grid grid-cols-4 w-full">
                            {user?.linkedin_link ? (
                                <a
                                    href={user?.linkedin_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-[#395BA9] w-fit rounded-full font-semibold p-2"
                                >
                                    <LinkedInIcon />
                                </a>
                            ) : null}
                            {user?.x_link ? (
                                <a
                                    href={user?.x_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-[#395BA9] w-fit rounded-full font-semibold p-2"
                                >
                                    <TwitterIcon />
                                </a>
                            ) : null}
                            {user?.facebook_link ? (
                                <a
                                    href={user?.facebook_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-[#395BA9] w-fit rounded-full font-semibold p-2"
                                >
                                    <FacebookIcon />
                                </a>
                            ) : null}
                            {user?.instagram_link ? (
                                <a
                                    href={user?.instagram_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-[#395BA9] w-fit rounded-full font-semibold p-2 text-white"
                                >
                                    <InstagramIcon />
                                </a>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>

            <img
                src="/img/business-card-sponsor.svg"
                className="absolute bottom-0 left-1/2 -translate-x-[50%] w-full z-[0] md:max-w-[520px] lg:rounded-b-3xl lg:relative lg:m-auto lg:translate-x-0 lg:left-0"
            />
        </div>
    );
}
